import axios from 'axios'
import mutations from './mutations.js'

export default {
  async get(context, payload) {
    context.commit('setLoader', {
      name: payload.loaderName,
      boolean: true
    })
    try {
      const response = await axios({
        method: 'get',
        url: `${payload.service}`,
        responseType: 'json',
        headers: {
          Authorization: `Bearer ${context.state.loggedUser.token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      context.commit('set', {
        itemName: payload.itemName,
        content: response.data
      })

      context.commit('setLoader', {
        name: payload.loaderName,
        boolean: false
      })
    } catch (error) {
      /*
      if (error.response.status === 404) {
        console.error('Nenhum item cadastrado')
        console.error(error)
        context.commit('set', {
          itemName: payload.itemName,
          content: []
        })
        context.commit('setLoader', {
          name: payload.loaderName,
          boolean: false
        })
      }
      */
    }
  },
  async new(context, payload) {
    context.commit('setLoader', {
      name: payload.loaderName,
      boolean: true
    })
    try {
      await axios({
        method: 'post',
        url: `${payload.service}`,
        responseType: 'json',
        headers: {
          Authorization: `Bearer ${context.state.loggedUser.token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload.newContent)
      })
      context.commit("snackSucesso");
      context.dispatch('get', {
        loaderName: payload.loaderName,
        service: payload.getService,
        itemName: payload.itemName
      })
      context.commit('setLoader', {
        itemName: payload.loaderName,
        content: 'false'
      })
    } catch (error) {
      if(error.hasOwnProperty("request")){
        if (error.request.status === 502) {
          var mensagemDeErro = error.request.response.message;
          context.commit("snackErro", mensagemDeErro)
        }else {
          context.commit("snackErro");
        }
      }else{
        context.commit("snackErro", "Houve um erro ao integrar o fornecedor");
      }
      context.commit('set', {
        itemName: payload.itemName,
        content: []
      })
      context.commit('setLoader', {
        name: payload.loaderName,
        boolean: false
      })
    }
  },
  async edit(context, payload) {
    context.commit('setLoader', {
      name: payload.loaderName,
      boolean: false
    })
    try {
      await axios({
        method: 'put',
        url: `${payload.service}`,
        responseType: 'json',
        headers: {
          Authorization: `Bearer ${context.state.loggedUser.token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload.editedContent)
      })
      context.commit("snackSucesso");
      context.dispatch('get', {
        loaderName: payload.loaderName,
        service: payload.getService,
        itemName: payload.itemName
      })
      context.commit('setLoader', {
        itemName: payload.loaderName,
        content: 'false'
      })
    } catch (error) {
      if(error.hasOwnProperty("request")){
        if (error.request.status === 502) {
          var mensagemDeErro = error.request.response.message;
          context.commit("snackErro", mensagemDeErro)
        }else {
          context.commit("snackErro");
        }
      }else{
        context.commit("snackErro", "Houve um erro ao atualizar o fornecedor");
      }
      context.commit('set', {
        itemName: payload.itemName,
        content: []
      })
      context.commit('setLoader', {
        name: payload.loaderName,
        boolean: false
      })
    }
  },
  async delete(context, payload) {
    context.commit('setLoader', {
      name: payload.loaderName,
      boolean: false
    })
    try {
      await axios({
        method: 'delete',
        url: `${payload.service}/${payload.editedContent.id}`,
        responseType: 'json',
        headers: {
          Authorization: `Bearer ${context.state.loggedUser.token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      context.dispatch('get', {
        loaderName: payload.loaderName,
        service: payload.getService,
        itemName: payload.itemName
      })
      context.commit('setLoader', {
        itemName: payload.loaderName,
        content: 'false'
      })
    } catch (error) {
      if (error.response.status === 404) {
        console.error('Erro no delete')
        console.error(error)
        context.commit('set', {
          itemName: payload.itemName,
          content: []
        })
        context.commit('setLoader', {
          name: payload.loaderName,
          boolean: false
        })
      }
    }

  },
  async ativarRefreshToken (context, payload) {
    let tokenFoiAtualizado = await mutations.refreshToken(context.state, payload);
    if(tokenFoiAtualizado){
      return tokenFoiAtualizado;
    } else {
      alert('Token não atualizado.');
      localStorage.clear();
      $router.push('/');
      return false;
    }
  }
}